<template>
  <div>
    <div class="info-box">
      <div class="title-box">
        <p>我的走访记录</p>
      </div>
      <div class="info-content" style="padding-bottom:0">
        <el-row :gutter="16" style="width:100%">
          <el-col :span="24">
            <el-card class="box-card">
              <el-input placeholder="学生姓名" v-model="search.support_user_name" clearable style="width: 200px"></el-input>
              <el-select v-model="search.support_user_sex" placeholder="学生性别" clearable style="width: 150px">
                <el-option :value="1" label="男"></el-option>
                <el-option :value="2" label="女"></el-option>
              </el-select>
              <el-input
                placeholder="所在学校"
                v-model="search.school_name"
                clearable
                style="width: 200px"
              ></el-input>
              <el-select
                v-model="search.suggest_result"
                placeholder="资助建议"
                clearable
                style="width: 150px"
              >
                <el-option :value="1" label="建议资助"></el-option>
                <el-option :value="2" label="不建议资助"></el-option>
                <el-option :value="3" label="难以决定"></el-option>
              </el-select>
              <el-select
                v-model="search.audit_status"
                placeholder="审核状态"
                clearable
                style="width: 150px"
              >
                <el-option :value="1" label="未审核"></el-option>
                <el-option :value="2" label="审核通过"></el-option>
                <el-option :value="3" label="审核不通过"></el-option>
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="$refs.visitTables.handleSearch()"
              >搜索</el-button>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="info-content">
        <div class="set-box">
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <WtDataList
                  v-model="data.list"
                  :url="$url.activity.visit.list"
                  :pageSize="10"
                  :search="search"
                  ref="visitTables"
                >
                  <div slot="list" style="padding:0 0 20px 0;">
                    <el-table :data="data.list" style="width: 100%" ref="table">
                      <el-table-column type="expand">
                        <template slot-scope="props">
                          <el-row :gutter="16">
                            <el-col :span="24">
                              <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                  <span>走访信息</span>
                                </div>
                                <div class="profile-header">
                                  <div class="profile-position">走访时间： {{props.row.visit_time}}</div>
                                  <div
                                    class="profile-position"
                                  >资助意见： {{props.row.suggest_result_text}}</div>
                                  <div class="profile-position">原因说明：{{props.row.suggest_reason}}</div>
                                </div>
                              </el-card>
                            </el-col>
                            <el-col :span="24">
                              <div class="section-body">
                                <ul class="list-group">
                                  <li class="list-group-item">
                                    <h3 class="text-primary">申请书正反面.</h3>
                                  </li>
                                  <li class="list-group-item">
                                    <viewer :images="props.row.apply_original_front_text">
                                      <img
                                        class="img"
                                        v-for="(item,index) in props.row.apply_original_front_text"
                                        :key="index"
                                        :src="item.path"
                                      />
                                      <img
                                        class="img"
                                        v-for="item in props.row.apply_original_back_text"
                                        :key="item.id"
                                        :src="item.path"
                                      />
                                    </viewer>
                                  </li>
                                </ul>
                              </div>

                              <div class="section-body">
                                <ul class="list-group">
                                  <li class="list-group-item">
                                    <h3 class="text-primary">家庭走访调查表正反面.</h3>
                                  </li>
                                  <li class="list-group-item">
                                    <viewer :images="props.row.visit_questionnaire_front_text">
                                      <img
                                        class="img"
                                        v-for="(item,index) in props.row.visit_questionnaire_front_text"
                                        :key="index"
                                        :src="item.path"
                                      />
                                      <img
                                        class="img"
                                        v-for="item in props.row.visit_questionnaire_back_text"
                                        :key="item.id"
                                        :src="item.path"
                                      />
                                    </viewer>
                                  </li>
                                </ul>
                              </div>

                              <div class="section-body">
                                <ul class="list-group">
                                  <li class="list-group-item">
                                    <h3 class="text-primary">家庭走访照片.</h3>
                                  </li>
                                  <li class="list-group-item">
                                    <viewer :images="props.row.subsidiary_files">
                                      <img
                                        class="img"
                                        v-for="(item,index) in props.row.subsidiary_files"
                                        :key="index"
                                        :src="item.file_detail.path"
                                      />
                                    </viewer>
                                  </li>
                                </ul>
                              </div>

                              <div>
                                <el-button type="primary" @click="toogleExpand(props.row)">关闭展开</el-button>
                              </div>
                            </el-col>
                          </el-row>
                        </template>
                      </el-table-column>
                      <el-table-column label="学生姓名" width="120" prop="support_user_name"></el-table-column>
                      <el-table-column label="性别" width="100" prop="support_user_sex_text"></el-table-column>
                      <el-table-column label="所在学校" prop="school_name"></el-table-column>
                      <el-table-column label="就读年级" width="120" prop="support_user_grade_text"></el-table-column>
                      <el-table-column label="走访时间" width="180" prop="visit_time"></el-table-column>
                      <el-table-column label="资助建议" width="180" prop="suggest_result_text"></el-table-column>
                      <el-table-column label="审核状态" width="150">
                        <template slot-scope="scope">
                          <div
                            v-if="scope.row.audit_status==1"
                            style="color:sandybrown"
                          >{{scope.row.audit_status_text}}</div>
                          <div
                            v-else-if="scope.row.audit_status==2"
                            style="color:green"
                          >{{scope.row.audit_status_text}}</div>
                          <div
                            v-else-if="scope.row.audit_status==3"
                            style="color:red"
                          >{{scope.row.audit_status_text}}</div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </WtDataList>
              </el-col>
            </el-row>
          </el-col>
        </div>
      </div>
    </div>
    <el-dialog title="反哺奖助学金申请审核" :visible.sync="dialogVisible" width="40%">
      <el-form ref="form" :model="auditDataModal" label-width="100px">
        <el-form-item label="审核结果：">
          <el-radio-group v-model="auditDataModal.audit_status">
            <el-radio :label="2">审核通过</el-radio>
            <el-radio :label="4">驳回修改（允许编辑后重新登记）</el-radio>
            <el-radio :label="3">审核拒绝（不允许再进行登记）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" v-model="auditDataModal.audit_note" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="auditDataSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      auditDataModal: {
        audit_status: 2,
        ids: []
      },
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      radio: 3,
      dialogVisible: false,
      data: {},
      search: {},

      navStatus: 1
    };
  },
  methods: {
    toogleExpand(row) {
      let $table = this.$refs.table;
      $table.toggleRowExpansion(row, false);
    },
    handleEdit(data) {
      console.log(data);
      this.auditDataModal.ids.push(data.id);
      this.dialogVisible = true;
    },
    getNav(id) {
      this.navStatus = id;
      this.$router.push({ name: "centerHomeIndex" });
    },
    auditDataSubmit() {
      let self = this;
      self.$db
        .post(self.$url.college.support.audit, self.auditDataModal)
        .then(resp => {
          if (resp) {
            this.$notify({
              title: "提示信息",
              message: "反哺奖助学金申请审核成功",
              type: "success"
            });
            //刷新窗口
            self.$refs.supportTables.reloadTable();
            self.dialogVisible = false;
          }
          self.auditDataModal.audit_status = 2;
          self.auditDataModal.audit_note = "";
          self.auditDataModal.ids = [];
        });
    }
  }
};
</script>


<style lang="scss" scoped>
.profile-position {
  padding: 5px 0;
  color: #515a6e;
}
.info-box {
  margin-top: 4.0740740740740744vh;
  .title-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    > p {
      color: #414c60;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
    > h5 {
      font-weight: normal;
      color: #8d95a4;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
  }
  .info-content {
    display: flex;
    justify-content: space-between;
    margin-top: 1.6666666666666666vh;
    padding-bottom: 4.351851851851852vh;
    .list-box {
      height: 19.518518518518517vh;
      width: 10.416666666666667vw;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      .list-time {
        height: 13.796296296296295vh;
        border-bottom: 1px solid #e4e5e9;
        overflow: hidden;
        > p {
          color: #414c60;
          font-size: 3.333333333333333vh;
          text-align: center;
          margin-top: 4.814814814814815vh;
          > span {
            color: #414c60;
            font-size: 1.6666666666666666vh;
            line-height: 1.6666666666666666vh;
          }
        }
        > i {
          display: block;
          width: 100%;
          font-style: normal;
          color: #8d95a4;
          font-size: 1.4814814814814815vh;
          // margin-top: 0.7259259259259259vh;
          text-align: center;
        }
      }
      .list-top {
        height: 13.796296296296295vh;
        border-bottom: 1px solid #e4e5e9;
        > p {
          color: #414c60;
          font-size: 3.333333333333333vh;
          line-height: 13.796296296296295vh;
          text-align: center;

          > span {
            color: #414c60;
            font-size: 1.6666666666666666vh;
            line-height: 1.6666666666666666vh;
          }
        }
        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 2.2222222222222223vh;
          line-height: 13.796296296296295vh;
          text-align: center;
        }
      }
      .list-bottom {
        height: 4.6296296296296294vh;
        position: relative;
        > p {
          color: #8d95a4;
          font-size: 1.4814814814814815vh;
          line-height: 1.4814814814814815vh;
          padding-left: 0.7291666666666667vw;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          > span {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #1caee0;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
    .set-box {
      //height: 19.518518518518517vh;
      //width: 30.833333333333335vw;
      width: 100%;
      padding: 15px;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      display: flex;
      justify-content: space-between;
      .set-info {
        padding-left: 9.895833333333333vw;
        height: 100%;
        position: relative;
        overflow: hidden;
        > img {
          width: 12.407407407407407vh;
          height: 12.407407407407407vh;
          border-radius: 50%;
          overflow: hidden;
          position: absolute;
          left: 1.8229166666666668vw;
          top: 50%;
          transform: translateY(-50%);
        }
        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 2.2222222222222223vh;
          line-height: 2.2222222222222223vh;
          margin-top: 5.185185185185185vh;
          margin-bottom: 1.5370370370370372vh;
        }
        > p {
          color: #8d95a4;
          font-size: 1.6666666666666666vh;
          line-height: 1.6666666666666666vh;
          margin-bottom: 1.2962962962962963vh;
        }
      }
      .set-btn {
        margin-right: 3.958333333333333vw;
        overflow: hidden;
        > h5 {
          font-weight: normal;
          font-size: 3.333333333333333vh;
          color: #1caee0;
          margin-top: 6.111111111111111vh;
        }
        > p {
          color: #1caee0;
          font-size: 1.4814814814814815vh;
          margin-top: 0.8407407407407408;
          text-align: center;
        }
      }
    }
  }
}
.c-bottom {
  display: flex;
  justify-content: space-between;
  .public-box {
    //width: 38.54166666666667vw;
    width: 100%;
    padding-bottom: 6.066666666666667vh;
    .public-title {
      display: flex;
      justify-content: space-between;
      width: 100%;
      > p {
        color: #414c60;
        font-size: 2.2222222222222223vh;
        line-height: 2.2222222222222223vh;
      }
      > h5 {
        font-weight: normal;
        color: #8d95a4;
        font-size: 2.2222222222222223vh;
        line-height: 2.2222222222222223vh;
      }
    }
    .train-box {
      width: 100%;
      //height: 44.44444444444444vh;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      margin-top: 1.6666666666666666vh;
      border: solid 1px #e6e7eb;
      overflow: hidden;
      .train-top {
        width: 100%;
        height: 34.16666666666667vh;
        > ul {
          padding: 4.6296296296296294vh 2.1875vw;
          > li {
            list-style: none;
            display: flex;
            margin-bottom: 5.3703703703703705vh;
            &:last-child {
              margin-bottom: 0;
            }
            .left-box {
              height: 4.4444444444444446vh;
              width: 5vw;
              border-right: 1px solid #e4e5e9;
              > h5 {
                font-weight: normal;
                color: #bfc0c8;
                font-size: 2.7777777777777776vh;
                line-height: 2.7777777777777776vh;
              }
              > p {
                font-size: 1.4814814814814815vh;
                color: #bfc0c8;
              }
            }
            .right-box {
              padding-left: 1.5625vw;
              //width: 26.666666666666666vw;
              > h5 {
                color: #414c60;
                font-size: 1.6666666666666666vh;
                line-height: 1.6666666666666666vh;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
                margin-bottom: 1.0037037037037037vh;
              }
              > p {
                color: #8d95a4;
                font-size: 1.2962962962962963vh;
                // line-height: 1.2962962962962963vh;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
              }
            }
          }
        }
      }
      .term-box {
        width: 100%;
        height: 34.16666666666667vh;
        > ul {
          padding: 4.6296296296296294vh 2.1875vw;
          li {
            list-style: none;
            display: flex;
            margin-bottom: 5vh;
            &:last-child {
              margin-bottom: 0;
            }
            > p {
              width: 4.0625vw;
              height: 2.3148148148148147vh;
              border-right: 1px solid #e4e5e9;
              font-size: 2.2222222222222223vh;
              line-height: 2.3148148148148147vh;
              color: #bfc0c8;
            }
            .score-box {
              width: 29.635416666666664vw;
              display: flex;
              justify-content: space-between;
              padding-left: 1.3020833333333334vw;
              > h5 {
                color: #414c60;
                font-size: 1.6666666666666666vh;
                line-height: 2.3148148148148147vh;
              }
              > p {
                > span {
                  font-size: 2.3666666666666666vh;
                  line-height: 2.3148148148148147vh;
                  color: #414c60;
                }
              }
            }
          }
        }
      }
      .train-bottom {
        height: 10.092592592592593vh;
        background-color: #1caee0;
        position: relative;
        > p {
          font-size: 2.2222222222222223vh;
          color: #fff;
          font-weight: 600;
          padding-left: 3.4895833333333334vw;
          line-height: 4.6296296296296294vh;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          > span {
            width: 4.6296296296296294vh;
            height: 4.6296296296296294vh;
            border-radius: 50%;
            background-color: #fff;
            color: #1caee0;
            font-size: 4.2222222222222223vh;
            line-height: 4.6296296296296294vh;
            text-align: center;
            position: absolute;
            left: 0;
            top: 0;
            font-weight: 100;
          }
          > i {
            font-style: normal;
            width: 4.6296296296296294vh;
            height: 4.6296296296296294vh;
            border-radius: 50%;
            background-color: #fff;
            color: #feb64d;
            font-size: 2.2222222222222223vh;
            line-height: 4.6296296296296294vh;
            text-align: center;
            position: absolute;
            left: 0;
            top: 0;
            font-weight: 100;
          }
        }
      }
    }
  }
}
</style>

<style scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.user-profile-name {
  display: inline-block;
  font-size: 22px;
  font-weight: 500;
  padding: 0px 15px;
}
.user-profile-tab {
  margin-top: 15px;
  padding: 0px 15px;
}
.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.contact-information,
.basic-information {
  margin: 10px 0px;
}
.contact-title {
  display: inline-block;
  padding-bottom: 15px;
  width: 170px;
  font-size: 16px;
  color: #868e96;
}
.phone-number,
.mail-address,
.contact-email,
.contact-website,
.contact-skype,
.birth-date,
.gender {
  font-size: 16px;
  color: #373757;
}

.section-body {
  overflow: hidden;
  box-shadow: 0 1px 2px transparent, 0 1px 4px rgba(0, 0, 0, 0.3);
  transition: All 0.5s ease;
  padding: 10px;
  margin-bottom: 25px;
}
.profile-right-section .section-body {
  margin-bottom: 5px;
}
.profile-right-section ul {
  margin-bottom: 0;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}
.list-group .list-group-item:first-child {
  border-radius: 0;
}
.profile-right-section ul li h3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}

.text-primary {
  color: #4390ff !important;
}
.profile-right-section ul li p {
  padding-bottom: 5px;
}
.profile-left-section .profile-title {
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.list-group-item img {
  width: 90px;
  height: 80px;
  margin: 0 5px 5px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/view/Center/visit/list.vue